import { render, staticRenderFns } from "./ScustomerDetail.vue?vue&type=template&id=88236d3e&"
import script from "./ScustomerDetail.vue?vue&type=script&lang=ts&"
export * from "./ScustomerDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports